import React from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import 'primeicons/primeicons.css';
import './AssistantMenu.css';

const AssistantMenu = () => {
  const items = [
    {
      label: 'Activities',
      icon: 'pi pi-bars',
      url: '/medi/assistantactivities',
    },
  ];

  return (
    <aside className="main-sidebar">
      <div className="menu">
        <div className="menu-container" style={{margin:'0px 10px'}}>
          <PanelMenu model={items} style={{backgroundColor:'#fff'}}/>
        </div>
      </div>
    </aside>
  );
};

export default AssistantMenu;
